import { GlobalOutlined } from '@ant-design/icons';
import { Button, Dropdown } from 'antd';
import type { MenuProps } from 'antd';

import { useLanguageStore, type Lang } from '@/store/languageStore';

const LANGUAGE_LABELS: Record<Lang, string> = {
  zh: '中文',
  en: 'English',
};

interface LanguageSwitchProps {
  /** Icon only (used on the login page). */
  compact?: boolean;
}

const LanguageSwitch = ({ compact = false }: LanguageSwitchProps) => {
  const lang = useLanguageStore((state) => state.lang);
  const setLang = useLanguageStore((state) => state.setLang);

  const items: MenuProps['items'] = (['zh', 'en'] as Lang[]).map((value) => ({
    key: value,
    label: LANGUAGE_LABELS[value],
  }));

  return (
    <Dropdown
      placement="bottomRight"
      menu={{
        items,
        selectable: true,
        selectedKeys: [lang],
        onClick: ({ key }) => setLang(key as Lang),
      }}
    >
      <Button
        type="text"
        icon={<GlobalOutlined />}
        title="中文 / English"
        className="text-gray-600 hover:text-blue-600"
      >
        {!compact && LANGUAGE_LABELS[lang]}
      </Button>
    </Dropdown>
  );
};

export default LanguageSwitch;
